import type { AbsoluteNode } from '@vedalib/editor'
import { isAbsoluteNode } from '@vedalib/editor'
import React from 'react'

import { nodeWithDeviceMode } from 'components/Editor/EditorContext/selectors/block'
import type { PreviewMode } from 'services/Store/Project/enums'

import type { IAbsoluteProps, INodeComponentProps } from '../Node/types'
import EditorAbsolute from './EditorAbsolute'
import PreviewAbsolute from './PreviewAbsolute'

const BLOCK_COMPONENTS: Partial<Record<PreviewMode, React.FC<IAbsoluteProps>>> = {
  editor: EditorAbsolute,
}

const Absolute: React.FC<INodeComponentProps<AbsoluteNode>> = (props) => {
  const { node, mode } = props
  const { style } = nodeWithDeviceMode(node, mode.deviceMode)
  const Component = BLOCK_COMPONENTS[mode.previewMode] || PreviewAbsolute

  if (isAbsoluteNode(node)) {
    return <Component {...props} node={node} style={style} />
  }

  return null
}

export default React.memo(Absolute)
